import React, { useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

function Cursos() {
  const videoRef = useRef(null);
  const [isMuted, setIsMuted] = useState(true);

  const toggleMute = () => {
    const video = videoRef.current;
    if (video) {
      video.muted = !video.muted;
      setIsMuted(video.muted);
    }
  };

  const styles = {
    footer: {
      background: 'linear-gradient(to right, #1786a0, #0f2d45)',
      color: '#fff',
      padding: '0px 10px',
      fontSize: '14px',
      width: '101%',
    },
    footerContent: {
      maxWidth: '700px',
      margin: '0 auto',
      textAlign: 'center',
      fontFamily: "'Montserrat', sans-serif",
    },
    footerTextCenter: {
      margin: '10px 0',
      lineHeight: '1.6',
    },
    footerLink: {
      color: '#ffffff',
      textDecoration: 'underline',
    },
    contactRow: {
      display: 'flex',
      justifyContent: 'space-around',
      flexWrap: 'wrap',
      gap: '10px',
      margin: '20px 0',
    },
    socialIconsClean: {
      display: 'flex',
      justifyContent: 'center',
      gap: '25px',
      margin: '20px 0 15px 0',
    },
    socialIcon: {
      width: '30px',
      height: '30px',
    },
    tiktokIcon: {
      width: '30px',
      height: '30px',
      filter: 'brightness(2)',
    },
  };

  return (
    <motion.div
      initial={{ x: '-100vw' }}
      animate={{ x: 0 }}
      transition={{ type: 'spring', stiffness: 50 }}
      style={{
        backgroundColor: '#F0F0F5',
        overflowX: 'hidden',
      }}
    >
      {/* VIDEO PANORÁMICO */}
      <div
        style={{
          position: 'relative',
          width: '100%',
          height: '80vh',
          overflow: 'hidden',
          top: 0,
          margin: 0,
          padding: 0,
        }}
      >
        <video
          ref={videoRef}
          src="/Cursos.mp4"
          autoPlay
          loop
          playsInline
          muted={isMuted}
          disablePictureInPicture
          onClick={toggleMute}
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            cursor: 'pointer',
          }}
        />
      </div>

      {/* Sección de imágenes tipo catálogo */}
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          gap: '40px',
          maxWidth: '1100px',
          flexWrap: 'wrap',
          margin: '60px auto',
        }}
      >
        <div style={{ textAlign: 'center' }}>
          <Link to="/vida-institucional-cursos" style={{ textDecoration: 'none', color: 'inherit' }}>
            <img
              src="/VidaE.jpg"
              alt="Vida Institucional Cursos"
              style={{
                width: '360px',
                height: '360px',
                objectFit: 'cover',
                display: 'block',
              }}
            />
            <h3
              style={{
                marginTop: '20px',
                fontSize: '22px',
                fontWeight: 'bold',
                letterSpacing: '1px',
                textTransform: 'uppercase',
              }}
            >
              VIDA INSTITUCIONAL CURSOS
            </h3>
          </Link>
        </div>

        <div style={{ textAlign: 'center' }}>
          <Link to="/catalogo-belleza" style={{ textDecoration: 'none', color: 'inherit' }}>
            <img
              src="/Cata.jpg"
              alt="Catálogo de Belleza"
              style={{
                width: '360px',
                height: '360px',
                objectFit: 'cover',
                display: 'block',
              }}
            />
            <h3
              style={{
                marginTop: '20px',
                fontSize: '22px',
                fontWeight: 'bold',
                letterSpacing: '1px',
                textTransform: 'uppercase',
              }}
            >
              CATÁLOGO DE BELLEZA
            </h3>
          </Link>
        </div>
      </div>

      {/* Footer */}
      <footer style={styles.footer}>
        <div style={styles.footerContent}>
          <p style={styles.footerTextCenter}>
            <strong>Instituto Grupo Impulsor Educativo</strong><br />
            <a
              href="https://maps.google.com/?q=Calzada Melchor Ocampo 204"
              target="_blank"
              rel="noopener noreferrer"
              style={styles.footerLink}
            >
              Calzada Melchor Ocampo 204
            </a>
          </p>

          <div style={styles.contactRow}>
            <p>Teléfono: 773-134-56-39 / 773-732-76-04</p>
            <p>Correo: grupoimpulsoreducativotula@gmail.com</p>
          </div>

          <div style={styles.socialIconsClean}>
            
            <a href="https://www.facebook.com/share/19RskfDHie/" target="_blank" rel="noreferrer">
              <img
                src="https://cdn-icons-png.flaticon.com/512/733/733547.png"
                alt="Facebook"
                style={styles.socialIcon}
              />
            </a>
            <a href="https://www.instagram.com/grupo_impulsor_educativo" target="_blank" rel="noreferrer">
              <img
                src="https://cdn-icons-png.flaticon.com/512/2111/2111463.png"
                alt="Instagram"
                style={styles.socialIcon}
              />
            </a>
            <a href="https://www.tiktok.com/@grupo_impulsor_educativo?is_from_webapp=1&sender_device=pc" target="_blank" rel="noreferrer">
              <img
                src="https://cdn-icons-png.flaticon.com/512/3046/3046122.png"
                alt="TikTok"
                style={styles.tiktokIcon}
              />
            </a>
          </div>

          <p style={styles.footerTextCenter}>
            Todos los derechos reservados a grupoimpulsoreducativo 2025
          </p>
        </div>
      </footer>
    </motion.div>
  );
}

export default Cursos;
